// import React, { useState, useEffect, useContext } from "react";
// import axios from "axios";
// import {
//   FiUser,
//   FiMail,
//   FiPhone,
//   FiLock,
//   FiBriefcase,
//   FiCalendar,
//   FiInfo,
//   FiEyeOff,
//   FiEye,
// } from "react-icons/fi";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import { AuthContext } from "../context/AuthContext";
// import { API_URL } from "../../Constants";

// const AccountForm = () => {
//   // Get current user from auth context
//   const { user } = useContext(AuthContext);
//   const currentAccountType = user?.accountType || "";

//   // Form state
//   const [formData, setFormData] = useState({
//     accountType: "",
//     fname: "",
//     lname: "",
//     email: "",
//     mobileNumber: "",
//     password: "",
//     companyName: "",
//     companyId: "",
//     validityFrom: "",
//     validityTo: "",
//     staffLimit: 0,
//     smsSendRate: "",
//     emailSendRate: "",
//     totalEmailAmount: "",
//     totalSMSAmount: "",
//     balanceExpiryDate: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isAccountCreatedSuccessful, setIsAccountCreatedSuccessful] =
//     useState(false);
//   const [staffLimitData, setStaffLimitData] = useState(null);
//   const [showPassword, setShowPassword] = useState(false);

//   // Toggle password visibility
//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//   };

//   // Get account types based on current user's account type
//   const getAccountTypes = () => {
//     switch (currentAccountType) {
//       case "SUPER_SUPER_ADMIN":
//         return [
//           { value: "SUPER_ADMIN", label: "Super Admin" },
//           { value: "RESELLER", label: "Reseller" },
//           { value: "COMPANY", label: "Company" },
//         ];
//       case "SUPER_ADMIN":
//         return [
//           { value: "RESELLER", label: "Reseller" },
//           { value: "COMPANY", label: "Company" },
//         ];
//       case "RESELLER":
//         return [{ value: "COMPANY", label: "Company" }];
//       case "COMPANY":
//         return [
//           { value: "VICE_PRESIDENT", label: "Vice President" },
//           { value: "MANAGER", label: "Manager" },
//           { value: "TEAM_LEAD", label: "Team Lead" },
//           { value: "HR", label: "HR" },
//           { value: "EXECUTIVE", label: "Executive" },
//         ];
//       case "VICE_PRESIDENT":
//         return [
//           { value: "MANAGER", label: "Manager" },
//           { value: "TEAM_LEAD", label: "Team Lead" },
//           { value: "HR", label: "HR" },
//           { value: "EXECUTIVE", label: "Executive" },
//         ];
//       case "MANAGER":
//         return [
//           { value: "TEAM_LEAD", label: "Team Lead" },
//           { value: "HR", label: "HR" },
//           { value: "EXECUTIVE", label: "Executive" },
//         ];
//       case "TEAM_LEAD":
//         return [
//           { value: "HR", label: "HR" },
//           { value: "EXECUTIVE", label: "Executive" },
//         ];
//       case "HR":
//         return [{ value: "EXECUTIVE", label: "Executive" }];
//       default:
//         return [];
//     }
//   };

//   const accountTypes = getAccountTypes();

//   // Handle input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "fname" || name === "lname") {
//       const regex = /^[a-zA-Z0-9\s]*$/;
//       if (!regex.test(value)) {
//         return;
//       }
//     }

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // Validate form fields
//   const validateForm = () => {
//     const newErrors = {};

//     // Common validations for all account types
//     if (!formData.accountType) {
//       newErrors.accountType = "Account type is required";
//     }
//     if (!formData.fname) {
//       newErrors.fname = "First name is required";
//     }
//     if (!formData.lname) {
//       newErrors.lname = "Last name is required";
//     }

//     // Email validation
//     if (!formData.email) {
//       newErrors.email = "Email is required";
//     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
//       newErrors.email = "Invalid email format";
//     }

//     // Phone validation
//     if (!formData.mobileNumber) {
//       newErrors.mobileNumber = "Phone is required";
//     } else if (!/^[0-9]{10,15}$/.test(formData.mobileNumber)) {
//       newErrors.mobileNumber = "Phone must be 10-15 digits";
//     }

//     // Password validation
//     if (!formData.password) {
//       newErrors.password = "Password is required";
//     } else if (formData.password.length < 8) {
//       newErrors.password = "Password must be at least 8 characters";
//     }

//     // Company name validation (only for certain account types)
//     if (
//       ![
//         "COMPANY",
//         "VICE_PRESIDENT",
//         "MANAGER",
//         "TEAM_LEAD",
//         "HR",
//         "EXECUTIVE",
//       ].includes(currentAccountType) &&
//       !formData.companyName
//     ) {
//       newErrors.companyName = "Company name is required";
//     }

//     // Validity dates validation (for SUPER_ADMIN, SUPER_SUPER_ADMIN, RESELLER)
//     if (
//       ["RESELLER", "SUPER_ADMIN", "SUPER_SUPER_ADMIN"].includes(
//         currentAccountType
//       )
//     ) {
//       if (!formData.validityFrom) {
//         newErrors.validityFrom = "Valid from date is required";
//       }
//       if (!formData.validityTo) {
//         newErrors.validityTo = "Valid to date is required";
//       }
//       // Ensure validityTo is after validityFrom if both exist
//       if (
//         formData.validityFrom &&
//         formData.validityTo &&
//         new Date(formData.validityTo) <= new Date(formData.validityFrom)
//       ) {
//         newErrors.validityTo = "Valid to date must be after valid from date";
//       }
//     }

//     // Additional validations for COMPANY accounts created by admin/reseller
//     if (
//       ["SUPER_SUPER_ADMIN", "SUPER_ADMIN", "RESELLER"].includes(
//         currentAccountType
//       ) &&
//       formData.accountType === "COMPANY"
//     ) {
//       if (!formData.staffLimit) {
//         newErrors.staffLimit = "Staff limit is required";
//       } else if (isNaN(formData.staffLimit) || formData.staffLimit < 0) {
//         newErrors.staffLimit = "Staff limit must be a positive number";
//       } else if (
//         currentAccountType !== "SUPER_SUPER_ADMIN" &&
//         staffLimitData &&
//         formData.staffLimit > staffLimitData.totalStaffLimit
//       ) {
//         newErrors.staffLimit = `Staff limit cannot exceed ${staffLimitData.totalStaffLimit}`;
//       }
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) return;

//     if (
//       ["SUPER_ADMIN", "RESELLER"].includes(currentAccountType) &&
//       formData.accountType === "COMPANY" &&
//       staffLimitData &&
//       formData.staffLimit > staffLimitData.totalStaffLimit
//     ) {
//       toast.error(
//         `Staff limit cannot exceed ${staffLimitData.totalStaffLimit}`
//       );
//       return;
//     }

//     setIsSubmitting(true);

//     try {
//       // Determine the API endpoint first
//       const url =
//         user?.accountType === "SUPER_SUPER_ADMIN" ||
//         user?.accountType === "SUPER_ADMIN" ||
//         user?.accountType === "RESELLER"
//           ? `${API_URL}/api/user/create`
//           : `${API_URL}/api/companyuser/create`;

//       // Prepare data for API
//       const payload = {
//         ...formData,
//         staffLimit: formData.staffLimit,
//         validityFrom: formData.validityFrom
//           ? new Date(formData.validityFrom).toISOString()
//           : null,
//         validityTo: formData.validityTo
//           ? new Date(formData.validityTo).toISOString()
//           : null,
//         accountCreatedById: user?.id || "",
//         accountCreatedByName: user?.name || "",
//         accountCreatedByEmail: user?.email || "",
//         accountCreatedByType: user?.accountType || "",
//         companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
//       };

//       // For company user creation, use the current user's company name
//       if (url.includes("/api/companyuser/create")) {
//         payload.companyName = user?.companyName;

//         // Remove fields that shouldn't be sent for company user creation
//         delete payload.staffLimit;
//         delete payload.smsSendRate;
//         delete payload.emailSendRate;
//         delete payload.validityFrom;
//         delete payload.validityTo;
//         delete payload.totalEmailAmount;
//         delete payload.totalSMSAmount;
//       }

//       try {
//         const response = await axios.post(url, payload, {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         });

//         // if (response == "OK") {
//         toast.success(
//           response.data ||
//             response?.data?.message ||
//             "Account Created Successfully"
//         );
//         // } else {
//         //   toast.success("Account created successfully.");
//         // }
//         setIsAccountCreatedSuccessful(true);
//       } catch (error) {
//         const errorMessage =
//           error.response?.data?.message ||
//           error.response?.data?.error ||
//           "Failed to create account. Please try again.";
//         toast.error(errorMessage);
//         console.error("Error creating account:", error);
//       } finally {
//         setFormData({
//           accountType: "",
//           fname: "",
//           lname: "",
//           email: "",
//           mobileNumber: "",
//           password: "",
//           companyName: "",
//           validityFrom: "",
//           validityTo: "",
//           staffLimit: 0,
//           smsSendRate: "",
//           emailSendRate: "",
//           totalEmailAmount: "",
//           totalSMSAmount: "",
//         });
//       }
//     } catch (error) {
//       console.error("Error in form submission:", error);
//       toast.error("An unexpected error occurred");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   // Reset form
//   const handleReset = () => {
//     setFormData({
//       accountType: "",
//       fname: "",
//       lname: "",
//       email: "",
//       mobileNumber: "",
//       password: "",
//       companyName: "",
//       validityFrom: "",
//       validityTo: "",
//       staffLimit: 0,
//       smsSendRate: "",
//       emailSendRate: "",
//       totalEmailAmount: "",
//       totalSMSAmount: "",
//     });
//     setErrors({});
//   };

//   // Show info banner for COMPANY and its sub-account types
//   // Show info banner for COMPANY, RESELLER, SUPER_ADMIN and their sub-account types
//   const showStaffCountInfo = [
//     "COMPANY",
//     "RESELLER",
//     "SUPER_ADMIN",
//     "VICE_PRESIDENT",
//     "MANAGER",
//     "TEAM_LEAD",
//     "HR",
//     "EXECUTIVE",
//   ].includes(currentAccountType);

//   // Check if we should show validity fields
//   const showValidityFields = [
//     "RESELLER",
//     "SUPER_ADMIN",
//     "SUPER_SUPER_ADMIN",
//   ].includes(currentAccountType);

//   // Fetch current staff count for COMPANY and its sub-account types
//   useEffect(() => {
//     const fetchStaffCount = async () => {
//       try {
//         const userIdOrCompanyId =
//           user?.accountType === "COMPANY" ? user?.id : user?.companyId;

//         let url = "";

//         if (["SUPER_ADMIN", "RESELLER"].includes(currentAccountType)) {
//           url = `${API_URL}/api/user/staffLimit/${user?.id}`;
//         } else if (
//           [
//             "COMPANY",
//             "VICE_PRESIDENT",
//             "MANAGER",
//             "TEAM_LEAD",
//             "HR",
//             "EXECUTIVE",
//           ].includes(currentAccountType)
//         ) {
//           url = `${API_URL}/api/companyuser/staffLimit/${userIdOrCompanyId}`;
//         }

//         if (url) {
//           const response = await axios.get(url, {
//             headers: {
//               Authorization: `Bearer ${localStorage.getItem("token")}`,
//             },
//           });
//           setStaffLimitData(response.data);
//         }
//       } catch (error) {
//         console.error("Error fetching staff count:", error);
//       }
//     };

//     if (showStaffCountInfo) {
//       fetchStaffCount();
//     }
//   }, [
//     currentAccountType,
//     user,
//     isAccountCreatedSuccessful,
//     showStaffCountInfo,
//   ]);

//   return (
//     <div className="min-h-screen bg-gray-100 dark:bg-gray-900 py-8 px-4 sm:px-6 lg:px-8 shadow-lg">
     

//       <div className="max-w-3xl mx-auto">
//         <div className="bg-gray-50 dark:bg-gray-900 dark:text-white shadow-xl rounded-lg overflow-hidden">
//           {/* Form Header */}
//           <div className="bg-gray-800 p-6">
//             <h2 className="text-2xl font-bold text-white">
//               Create New Account
//             </h2>
//             <p className="text-white mt-1">
//               Please fill in the account details
//             </p>
//           </div>

//           {/* Staff Count Info Banner */}
//           {showStaffCountInfo && staffLimitData && (
//             <div className="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4">
//               <div className="flex items-center">
//                 <FiInfo className="h-5 w-5 mr-2" />
//                 <p>
//                   {[
//                     "COMPANY",
//                     "VICE_PRESIDENT",
//                     "MANAGER",
//                     "TEAM_LEAD",
//                     "HR",
//                     "EXECUTIVE",
//                   ].includes(currentAccountType) ? (
//                     <>
//                       Your STAFF-COUNT is{" "}
//                       <strong>
//                         {staffLimitData.totalStaffLimit} (Remaining:{" "}
//                         {staffLimitData.remainingStaffLimit})
//                       </strong>
//                     </>
//                   ) : (
//                     <>
//                       Remaining Your Staff-COUNT-LIMIT to Provide is{" "}
//                       <strong>
//                         {staffLimitData.totalStaffLimit}
//                         {/* {staffLimitData.remainingStaffLimit}) */}
//                       </strong>
//                     </>
//                   )}
//                 </p>
//               </div>
//             </div>
//           )}

//           {/* Form Body */}
//           <form onSubmit={handleSubmit} className="p-6 space-y-6">
//             <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 ">
//               {/* Account Type */}
//               <div className="relative ">
//                 <label
//                   htmlFor="accountType"
//                   className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
//                 >
//                   Account Type <span className="text-red-500">*</span>
//                 </label>
//                 <div className="relative">
//                   <select
//                     id="accountType"
//                     name="accountType"
//                     value={formData.accountType}
//                     onChange={handleChange}
//                     className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:text-white"
//                   >
//                     <option value="">Select account type</option>
//                     {accountTypes.map((type) => (
//                       <option key={type.value} value={type.value}>
//                         {type.label}
//                       </option>
//                     ))}
//                   </select>
//                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                     <FiUser className="h-5 w-5 text-gray-400" />
//                   </div>
//                 </div>
//                 {errors.accountType && (
//                   <p className="mt-1 text-sm text-red-600">
//                     {errors.accountType}
//                   </p>
//                 )}
//               </div>

//               {/* Company Name (now always visible) */}
//               {![
//                 "COMPANY",
//                 "VICE_PRESIDENT",
//                 "MANAGER",
//                 "TEAM_LEAD",
//                 "HR",
//               ].includes(user.accountType) && (
//                 <div className="relative">
//                   <label
//                     htmlFor="companyName"
//                     className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
//                   >
//                     Company Name <span className="text-red-500">*</span>
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="text"
//                       id="companyName"
//                       name="companyName"
//                       value={formData.companyName}
//                       onChange={handleChange}
//                       className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 dark:bg-gray-900 dark:text-white focus:border-blue-500"
//                       placeholder="Enter company name"
//                     />
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <FiBriefcase className="h-5 w-5 text-gray-400" />
//                     </div>
//                   </div>
//                   {errors.companyName && (
//                     <p className="mt-1 text-sm text-red-600">
//                       {errors.companyName}
//                     </p>
//                   )}
//                 </div>
//               )}
//             </div>

//             {/* Additional fields for COMPANY when created by SUPER_SUPER_ADMIN, SUPER_ADMIN or RESELLER */}
//             {/* {["SUPER_SUPER_ADMIN", "SUPER_ADMIN", "RESELLER"].includes(
//               currentAccountType
//             ) &&
//               ["COMPANY", "SUPER_ADMIN", "RESELLER"].includes(
//                 formData.accountType
//               ) && ( */}

//             <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
//               {/* First Name */}
//               <div className="relative">
//                 <label
//                   htmlFor="fname"
//                   className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
//                 >
//                   First Name <span className="text-red-500">*</span>
//                 </label>
//                 <div className="relative">
//                   <input
//                     type="text"
//                     id="fname"
//                     name="fname"
//                     value={formData.fname}
//                     onChange={handleChange}
//                     pattern="[a-zA-Z0-9\s]+"
//                     title="Only letters and numbers are allowed"
//                     className="block w-full pl-10 pr-3 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
//                     placeholder="Enter first name"
//                   />
//                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                     <FiUser className="h-5 w-5 text-gray-400" />
//                   </div>
//                 </div>
//                 {errors.fname && (
//                   <p className="mt-1 text-sm text-red-600">{errors.fname}</p>
//                 )}
//               </div>

//               {/* Last Name */}
//               <div className="relative">
//                 <label
//                   htmlFor="lname"
//                   className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
//                 >
//                   Last Name <span className="text-red-500">*</span>
//                 </label>
//                 <div className="relative">
//                   <input
//                     type="text"
//                     id="lname"
//                     name="lname"
//                     value={formData.lname}
//                     onChange={handleChange}
//                     pattern="[a-zA-Z0-9\s]+"
//                     title="Only letters and numbers are allowed"
//                     className="block w-full pl-10 pr-3 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
//                     placeholder="Enter last name"
//                   />
//                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                     <FiUser className="h-5 w-5 text-gray-400" />
//                   </div>
//                 </div>
//                 {errors.lname && (
//                   <p className="mt-1 text-sm text-red-600">{errors.lname}</p>
//                 )}
//               </div>
//             </div>

//             <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
//               {/* Email */}
//               <div className="relative">
//                 <label
//                   htmlFor="email"
//                   className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
//                 >
//                   Email <span className="text-red-500">*</span>
//                 </label>
//                 <div className="relative">
//                   <input
//                     type="email"
//                     id="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     className="block w-full pl-10 pr-3 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
//                     placeholder="Enter email address"
//                   />
//                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                     <FiMail className="h-5 w-5 text-gray-400" />
//                   </div>
//                 </div>
//                 {errors.email && (
//                   <p className="mt-1 text-sm text-red-600">{errors.email}</p>
//                 )}
//               </div>

//               {/* Phone */}
//               <div className="relative">
//                 <label
//                   htmlFor="mobileNumber"
//                   className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
//                 >
//                   Phone <span className="text-red-500">*</span>
//                 </label>
//                 <div className="relative">
//                   <input
//                     type="number"
//                     id="mobileNumber"
//                     name="mobileNumber"
//                     value={formData.mobileNumber}
//                     onChange={handleChange}
//                     className="block w-full pl-10 pr-3 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
//                     placeholder="Enter phone number"
//                   />
//                   <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                     <FiPhone className="h-5 w-5 text-gray-400" />
//                   </div>
//                 </div>
//                 {errors.mobileNumber && (
//                   <p className="mt-1 text-sm text-red-600">
//                     {errors.mobileNumber}
//                   </p>
//                 )}
//               </div>
//             </div>

//             {![
//               "COMPANY",
//               "VICE_PRESIDENT",
//               "MANAGER",
//               "TEAM_LEAD",
//               "HR",
//             ].includes(user.accountType) && (
//               <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
//                 <div className="relative">
//                   <label
//                     htmlFor="staffLimit"
//                     className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
//                   >
//                     Staff Limit
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="number"
//                       id="staffLimit"
//                       name="staffLimit"
//                       min="0"
//                       {...(user.accountType !== "SUPER_SUPER_ADMIN" && {
//                         max: staffLimitData?.totalStaffLimit || 0,
//                       })}
//                       value={formData.staffLimit}
//                       onChange={handleChange}
//                       className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 dark:bg-gray-900 dark:text-white focus:border-blue-500"
//                       placeholder="Enter staff limit"
//                     />
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <FiUser className="h-5 w-5 text-gray-400" />
//                     </div>
//                   </div>
//                   {errors.staffLimit && (
//                     <p className="mt-1 text-sm text-red-600">
//                       {errors.staffLimit}
//                     </p>
//                   )}
//                 </div>
//                 <div className="relative">
//                   <label
//                     htmlFor="smsSendRate"
//                     className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
//                   >
//                     SMS Rate
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="number"
//                       step="0.01"
//                       min="0"
//                       id="smsSendRate"
//                       name="smsSendRate"
//                       value={formData.smsSendRate}
//                       onChange={handleChange}
//                       className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 dark:bg-gray-900 dark:text-white focus:border-blue-500"
//                       placeholder="Enter SMS rate"
//                     />
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <FiMail className="h-5 w-5 text-gray-400" />
//                     </div>
//                   </div>
//                   {/* {errors.smsSendRate && (
//                       <p className="mt-1 text-sm text-red-600">
//                         {errors.smsSendRate}
//                       </p>
//                     )} */}
//                 </div>

//                 <div className="relative">
//                   <label
//                     htmlFor="emailSendRate"
//                     className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
//                   >
//                     Email Rate
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="number"
//                       step="0.01"
//                       min="0"
//                       id="emailSendRate"
//                       name="emailSendRate"
//                       value={formData.emailSendRate}
//                       onChange={handleChange}
//                       className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 dark:bg-gray-900 dark:text-white focus:border-blue-500"
//                       placeholder="Enter email rate"
//                     />
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <FiMail className="h-5 w-5 text-gray-400" />
//                     </div>
//                   </div>
//                   {/* {errors.emailSendRate && (
//                       <p className="mt-1 text-sm text-red-600">
//                         {errors.emailSendRate}
//                       </p>
//                     )} */}
//                 </div>
//               </div>
//             )}

//             {![
//               "COMPANY",
//               "VICE_PRESIDENT",
//               "MANAGER",
//               "TEAM_LEAD",
//               "HR",
//             ].includes(user.accountType) && (
//               <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
//                 {/* Total SMS Amount */}
//                 <div className="relative">
//                   <label
//                     htmlFor="totalSMSAmount"
//                     className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
//                   >
//                     Total SMS Amount
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="number"
//                       id="totalSMSAmount"
//                       name="totalSMSAmount"
//                       min="0"
//                       value={formData.totalSMSAmount}
//                       onChange={handleChange}
//                       className="block w-full pl-10 pr-3 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
//                       placeholder="Enter Total SMS Amount"
//                     />
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <FiUser className="h-5 w-5 text-gray-400" />
//                     </div>
//                   </div>
//                   {/* {errors.fname && (
//                   <p className="mt-1 text-sm text-red-600">{errors.fname}</p>
//                 )} */}
//                 </div>

//                 {/* Total Email Amount */}
//                 <div className="relative">
//                   <label
//                     htmlFor="totalEmailAmount"
//                     className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
//                   >
//                     Total Email Amount
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="number"
//                       id="totalEmailAmount"
//                       name="totalEmailAmount"
//                       min="0"
//                       value={formData.totalEmailAmount}
//                       onChange={handleChange}
//                       className="block w-full pl-10 pr-3 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
//                       placeholder="Enter Total Email Amount"
//                     />
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <FiUser className="h-5 w-5 text-gray-400" />
//                     </div>
//                   </div>
//                 </div>
//                 {/* {errors.lname && (
//                   <p className="mt-1 text-sm text-red-600">{errors.lname}</p>
//                 )} */}

//                 <div className="relative w-full">
//                   <label
//                     htmlFor="balanceExpiryDate"
//                     className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
//                   >
//                     Balance Expiry Date <span className="text-red-500">*</span>
//                   </label>

//                   <div className="relative">
//                     {/* Calendar Icon */}
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <FiCalendar className="h-5 w-5 text-gray-400" />
//                     </div>

//                     {/* Date Input */}
//                     <input
//                       type="date"
//                       id="balanceExpiryDate"
//                       name="balanceExpiryDate"
//                       min={new Date().toISOString().split("T")[0]}
//                       value={formData.balanceExpiryDate}
//                       onChange={handleChange}
//                       className="block w-full pl-10 pr-10 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
//                     />
//                   </div>

//                   {/* Error Message */}
//                   {errors.balanceExpiryDate && (
//                     <p className="mt-1 text-sm text-red-600">
//                       {errors.balanceExpiryDate}
//                     </p>
//                   )}
//                 </div>
//               </div>
//             )}

//             {/* Password */}
//             <div className="relative">
//               <label
//                 htmlFor="password"
//                 className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
//               >
//                 Password <span className="text-red-500">*</span>
//               </label>
//               <div className="relative">
//                 <input
//                   type={showPassword ? "text" : "password"}
//                   id="password"
//                   name="password"
//                   value={formData.password}
//                   onChange={handleChange}
//                   className="block w-full pl-10 pr-10 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
//                   placeholder="Enter password"
//                 />
//                 <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                   <FiLock className="h-5 w-5 text-gray-400" />
//                 </div>
//                 <button
//                   type="button"
//                   className="absolute inset-y-0 right-0 pr-3 flex items-center"
//                   onClick={togglePasswordVisibility}
//                 >
//                   {showPassword ? (
//                     <FiEyeOff className="h-5 w-5 text-gray-400 hover:text-gray-500" />
//                   ) : (
//                     <FiEye className="h-5 w-5 text-gray-400 hover:text-gray-500" />
//                   )}
//                 </button>
//               </div>
//               {errors.password && (
//                 <p className="mt-1 text-sm text-red-600">{errors.password}</p>
//               )}
//             </div>

//             <div
//               className={`grid gap-6 ${
//                 showValidityFields ? "sm:grid-cols-3" : "sm:grid-cols-1"
//               }`}
//             >
//               {/* Valid From - only shown for Reseller, SUPER_ADMIN, SUPER_SUPER_ADMIN */}
//               {showValidityFields && (
//                 <div className="relative">
//                   <label
//                     htmlFor="validityFrom"
//                     className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
//                   >
//                     Valid From <span className="text-red-500">*</span>
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="date"
//                       id="validityFrom"
//                       name="validityFrom"
//                       min={new Date().toISOString().split("T")[0]}
//                       value={formData.validityFrom}
//                       onChange={handleChange}
//                       className="block w-full pl-10 pr-3 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
//                     />
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <FiCalendar className="h-5 w-5 text-gray-400" />
//                     </div>
//                   </div>
//                   {errors.validityFrom && (
//                     <p className="mt-1 text-sm text-red-600">
//                       {errors.validityFrom}
//                     </p>
//                   )}
//                 </div>
//               )}

//               {/* Valid To - only shown for Reseller, SUPER_ADMIN, SUPER_SUPER_ADMIN */}
//               {showValidityFields && (
//                 <div className="relative">
//                   <label
//                     htmlFor="validityTo"
//                     className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
//                   >
//                     Valid To <span className="text-red-500">*</span>
//                   </label>
//                   <div className="relative">
//                     <input
//                       type="date"
//                       id="validityTo"
//                       name="validityTo"
//                       value={formData.validityTo}
//                       min={new Date().toISOString().split("T")[0]}
//                       onChange={handleChange}
//                       className="block w-full pl-10 pr-3 py-2 dark:bg-gray-900 dark:text-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
//                     />
//                     <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
//                       <FiCalendar className="h-5 w-5 text-gray-400" />
//                     </div>
//                   </div>
//                   {errors.validTo && (
//                     <p className="mt-1 text-sm text-red-600">
//                       {errors.validityTo}
//                     </p>
//                   )}
//                 </div>
//               )}
//             </div>

//             {/* Form Actions */}
//             <div className="flex justify-end space-x-4 pt-6">
//               <button
//                 type="button"
//                 onClick={handleReset}
//                 className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
//               >
//                 Reset
//               </button>
//               <button
//                 type="submit"
//                 disabled={isSubmitting}
//                 className={`px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#673AB7] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
//                   isSubmitting ? "opacity-75 cursor-not-allowed" : ""
//                 }`}
//               >
//                 {isSubmitting ? (
//                   <>
//                     <svg
//                       className="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline"
//                       xmlns="http://www.w3.org/2000/svg"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                     >
//                       <circle
//                         className="opacity-25"
//                         cx="12"
//                         cy="12"
//                         r="10"
//                         stroke="currentColor"
//                         strokeWidth="4"
//                       ></circle>
//                       <path
//                         className="opacity-75"
//                         fill="currentColor"
//                         d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                       ></path>
//                     </svg>
//                     Processing...
//                   </>
//                 ) : (
//                   "Create Account"
//                 )}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AccountForm;








import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import {
  FiUser,
  FiMail,
  FiPhone,
  FiLock,
  FiBriefcase,
  FiCalendar,
  FiInfo,
  FiEyeOff,
  FiEye,
} from "react-icons/fi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthContext } from "../context/AuthContext";
import { API_URL } from "../../Constants";

const AccountForm = () => {
  // Get current user from auth context
  const { user } = useContext(AuthContext);
  const currentAccountType = user?.accountType || "";

  // Form state
  const [formData, setFormData] = useState({
    accountType: "",
    fname: "",
    lname: "",
    email: "",
    mobileNumber: "",
    password: "",
    companyName: "",
    companyId: "",
    validityFrom: "",
    validityTo: "",
    staffLimit: 0,
    smsSendRate: "",
    emailSendRate: "",
    totalEmailAmount: "",
    totalSMSAmount: "",
    balanceExpiryDate: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isAccountCreatedSuccessful, setIsAccountCreatedSuccessful] =
    useState(false);
  const [staffLimitData, setStaffLimitData] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  // Toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  // Get account types based on current user's account type
  const getAccountTypes = () => {
    switch (currentAccountType) {
      case "SUPER_SUPER_ADMIN":
        return [
          { value: "SUPER_ADMIN", label: "Super Admin" },
          { value: "RESELLER", label: "Reseller" },
          { value: "COMPANY", label: "Company" },
        ];
      case "SUPER_ADMIN":
        return [
          { value: "RESELLER", label: "Reseller" },
          { value: "COMPANY", label: "Company" },
        ];
      case "RESELLER":
        return [{ value: "COMPANY", label: "Company" }];
      case "COMPANY":
        return [
          { value: "VICE_PRESIDENT", label: "Vice President" },
          { value: "MANAGER", label: "Manager" },
          { value: "TEAM_LEAD", label: "Team Lead" },
          { value: "HR", label: "HR" },
          { value: "EXECUTIVE", label: "Executive" },
        ];
      case "VICE_PRESIDENT":
        return [
          { value: "MANAGER", label: "Manager" },
          { value: "TEAM_LEAD", label: "Team Lead" },
          { value: "HR", label: "HR" },
          { value: "EXECUTIVE", label: "Executive" },
        ];
      case "MANAGER":
        return [
          { value: "TEAM_LEAD", label: "Team Lead" },
          { value: "HR", label: "HR" },
          { value: "EXECUTIVE", label: "Executive" },
        ];
      case "TEAM_LEAD":
        return [
          { value: "HR", label: "HR" },
          { value: "EXECUTIVE", label: "Executive" },
        ];
      case "HR":
        return [{ value: "EXECUTIVE", label: "Executive" }];
      default:
        return [];
    }
  };

  const accountTypes = getAccountTypes();

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "fname" || name === "lname") {
      const regex = /^[a-zA-Z0-9\s]*$/;
      if (!regex.test(value)) {
        return;
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Validate form fields
  const validateForm = () => {
    const newErrors = {};

    // Common validations for all account types
    if (!formData.accountType) {
      newErrors.accountType = "Account type is required";
    }
    if (!formData.fname) {
      newErrors.fname = "First name is required";
    }
    if (!formData.lname) {
      newErrors.lname = "Last name is required";
    }

    // Email validation
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    // Phone validation
    if (!formData.mobileNumber) {
      newErrors.mobileNumber = "Phone is required";
    }

    // Password validation
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters";
    }

    // Company name validation (only for certain account types)
    if (
      ![
        "COMPANY",
        "VICE_PRESIDENT",
        "MANAGER",
        "TEAM_LEAD",
        "HR",
        "EXECUTIVE",
      ].includes(currentAccountType) &&
      !formData.companyName
    ) {
      newErrors.companyName = "Company name is required";
    }

    // Validity dates validation (for SUPER_ADMIN, SUPER_SUPER_ADMIN, RESELLER)
    if (
      ["RESELLER", "SUPER_ADMIN", "SUPER_SUPER_ADMIN"].includes(
        currentAccountType
      )
    ) {
      if (!formData.validityFrom) {
        newErrors.validityFrom = "Valid from date is required";
      }
      if (!formData.validityTo) {
        newErrors.validityTo = "Valid to date is required";
      }
      // Ensure validityTo is after validityFrom if both exist
      if (
        formData.validityFrom &&
        formData.validityTo &&
        new Date(formData.validityTo) <= new Date(formData.validityFrom)
      ) {
        newErrors.validityTo = "Valid to date must be after valid from date";
      }
    }

    // Additional validations for COMPANY accounts created by admin/reseller
    if (
      ["SUPER_SUPER_ADMIN", "SUPER_ADMIN", "RESELLER"].includes(
        currentAccountType
      ) &&
      formData.accountType === "COMPANY"
    ) {
      if (!formData.staffLimit) {
        newErrors.staffLimit = "Staff limit is required";
      } else if (isNaN(formData.staffLimit) || formData.staffLimit < 0) {
        newErrors.staffLimit = "Staff limit must be a positive number";
      } else if (
        currentAccountType !== "SUPER_SUPER_ADMIN" &&
        staffLimitData &&
        formData.staffLimit > staffLimitData.totalStaffLimit
      ) {
        newErrors.staffLimit = `Staff limit cannot exceed ${staffLimitData.totalStaffLimit}`;
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    if (
      ["SUPER_ADMIN", "RESELLER"].includes(currentAccountType) &&
      formData.accountType === "COMPANY" &&
      staffLimitData &&
      formData.staffLimit > staffLimitData.totalStaffLimit
    ) {
      toast.error(
        `Staff limit cannot exceed ${staffLimitData.totalStaffLimit}`
      );
      return;
    }

    setIsSubmitting(true);

    try {
      // Determine the API endpoint first
      const url =
        user?.accountType === "SUPER_SUPER_ADMIN" ||
        user?.accountType === "SUPER_ADMIN" ||
        user?.accountType === "RESELLER"
          ? `${API_URL}/api/user/create`
          : `${API_URL}/api/companyuser/create`;

      // Prepare data for API
      const payload = {
        ...formData,
        staffLimit: formData.staffLimit,
        validityFrom: formData.validityFrom
          ? new Date(formData.validityFrom).toISOString()
          : null,
        validityTo: formData.validityTo
          ? new Date(formData.validityTo).toISOString()
          : null,
        accountCreatedById: user?.id || "",
        accountCreatedByName: user?.name || "",
        accountCreatedByEmail: user?.email || "",
        accountCreatedByType: user?.accountType || "",
        companyId: user?.accountType === "COMPANY" ? user?.id : user?.companyId,
      };

      // For company user creation, use the current user's company name
      if (url.includes("/api/companyuser/create")) {
        payload.companyName = user?.companyName;

        // Remove fields that shouldn't be sent for company user creation
        delete payload.staffLimit;
        delete payload.smsSendRate;
        delete payload.emailSendRate;
        delete payload.validityFrom;
        delete payload.validityTo;
        delete payload.totalEmailAmount;
        delete payload.totalSMSAmount;
      }

      try {
        const response = await axios.post(url, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        // if (response == "OK") {
        toast.success(
          response.data ||
            response?.data?.message ||
            "Account Created Successfully"
        );
        // } else {
        //   toast.success("Account created successfully.");
        // }
        setIsAccountCreatedSuccessful(true);
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Failed to create account. Please try again.";
        toast.error(errorMessage);
        console.error("Error creating account:", error);
      } finally {
        setFormData({
          accountType: "",
          fname: "",
          lname: "",
          email: "",
          mobileNumber: "",
          password: "",
          companyName: "",
          validityFrom: "",
          validityTo: "",
          staffLimit: 0,
          smsSendRate: "",
          emailSendRate: "",
          totalEmailAmount: "",
          totalSMSAmount: "",
        });
      }
    } catch (error) {
      console.error("Error in form submission:", error);
      toast.error("An unexpected error occurred");
    } finally {
      setIsSubmitting(false);
    }
  };

  // Reset form
  const handleReset = () => {
    setFormData({
      accountType: "",
      fname: "",
      lname: "",
      email: "",
      mobileNumber: "",
      password: "",
      companyName: "",
      validityFrom: "",
      validityTo: "",
      staffLimit: 0,
      smsSendRate: "",
      emailSendRate: "",
      totalEmailAmount: "",
      totalSMSAmount: "",
    });
    setErrors({});
  };

  // Show info banner for COMPANY and its sub-account types
  // Show info banner for COMPANY, RESELLER, SUPER_ADMIN and their sub-account types
  const showStaffCountInfo = [
    "COMPANY",
    "RESELLER",
    "SUPER_ADMIN",
    "VICE_PRESIDENT",
    "MANAGER",
    "TEAM_LEAD",
    "HR",
    "EXECUTIVE",
  ].includes(currentAccountType);

  // Check if we should show validity fields
  const showValidityFields = [
    "RESELLER",
    "SUPER_ADMIN",
    "SUPER_SUPER_ADMIN",
  ].includes(currentAccountType);

  // Fetch current staff count for COMPANY and its sub-account types
  useEffect(() => {
    const fetchStaffCount = async () => {
      try {
        const userIdOrCompanyId =
          user?.accountType === "COMPANY" ? user?.id : user?.companyId;

        let url = "";

        if (["SUPER_ADMIN", "RESELLER"].includes(currentAccountType)) {
          url = `${API_URL}/api/user/staffLimit/${user?.id}`;
        } else if (
          [
            "COMPANY",
            "VICE_PRESIDENT",
            "MANAGER",
            "TEAM_LEAD",
            "HR",
            "EXECUTIVE",
          ].includes(currentAccountType)
        ) {
          url = `${API_URL}/api/companyuser/staffLimit/${userIdOrCompanyId}`;
        }

        if (url) {
          const response = await axios.get(url, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          });
          setStaffLimitData(response.data);
        }
      } catch (error) {
        console.error("Error fetching staff count:", error);
      }
    };

    if (showStaffCountInfo) {
      fetchStaffCount();
    }
  }, [
    currentAccountType,
    user,
    isAccountCreatedSuccessful,
    showStaffCountInfo,
  ]);

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 py-8 px-4 sm:px-6 lg:px-8 shadow-lg">
      <div className="max-w-3xl mx-auto">
        <div className="bg-gray-50 dark:bg-gray-900 dark:text-white shadow-xl rounded-lg overflow-hidden">
          {/* Form Header */}
          <div className="bg-gray-800 p-6">
            <h2 className="text-2xl font-bold text-white">
              Create New Account
            </h2>
            <p className="text-white mt-1">
              Please fill in the account details
            </p>
          </div>

          {/* Staff Count Info Banner */}
          {showStaffCountInfo && staffLimitData && (
            <div className="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4">
              <div className="flex items-center">
                <FiInfo className="h-5 w-5 mr-2" />
                <p>
                  {[
                    "COMPANY",
                    "VICE_PRESIDENT",
                    "MANAGER",
                    "TEAM_LEAD",
                    "HR",
                    "EXECUTIVE",
                  ].includes(currentAccountType) ? (
                    <>
                      Your STAFF-COUNT is{" "}
                      <strong>
                        {staffLimitData.totalStaffLimit} (Remaining:{" "}
                        {staffLimitData.remainingStaffLimit})
                      </strong>
                    </>
                  ) : (
                    <>
                      Remaining Your Staff-COUNT-LIMIT to Provide is{" "}
                      <strong>
                        {staffLimitData.totalStaffLimit}
                        {/* {staffLimitData.remainingStaffLimit}) */}
                      </strong>
                    </>
                  )}
                </p>
              </div>
            </div>
          )}

          {/* Form Body */}
          <form onSubmit={handleSubmit} className="p-6 space-y-6">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 ">
              {/* Account Type */}
              <div className="relative ">
                <label
                  htmlFor="accountType"
                  className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
                >
                  Account Type <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <select
                    id="accountType"
                    name="accountType"
                    value={formData.accountType}
                    onChange={handleChange}
                    className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-900 dark:text-white"
                  >
                    <option value="">Select account type</option>
                    {accountTypes.map((type) => (
                      <option key={type.value} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </select>
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FiUser className="h-5 w-5 text-gray-400" />
                  </div>
                </div>
                {errors.accountType && (
                  <p className="mt-1 text-sm text-red-600">
                    {errors.accountType}
                  </p>
                )}
              </div>

              {/* Company Name (now always visible) */}
              {![
                "COMPANY",
                "VICE_PRESIDENT",
                "MANAGER",
                "TEAM_LEAD",
                "HR",
              ].includes(user.accountType) && (
                <div className="relative">
                  <label
                    htmlFor="companyName"
                    className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
                  >
                    Company Name <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      id="companyName"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 dark:bg-gray-900 dark:text-white focus:border-blue-500"
                      placeholder="Enter company name"
                    />
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <FiBriefcase className="h-5 w-5 text-gray-400" />
                    </div>
                  </div>
                  {errors.companyName && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors.companyName}
                    </p>
                  )}
                </div>
              )}
            </div>

            {/* Additional fields for COMPANY when created by SUPER_SUPER_ADMIN, SUPER_ADMIN or RESELLER */}
            {/* {["SUPER_SUPER_ADMIN", "SUPER_ADMIN", "RESELLER"].includes(
              currentAccountType
            ) &&
              ["COMPANY", "SUPER_ADMIN", "RESELLER"].includes(
                formData.accountType
              ) && ( */}

            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              {/* First Name */}
              <div className="relative">
                <label
                  htmlFor="fname"
                  className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
                >
                  First Name <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <input
                    type="text"
                    id="fname"
                    name="fname"
                    value={formData.fname}
                    onChange={handleChange}
                    pattern="[a-zA-Z0-9\s]+"
                    title="Only letters and numbers are allowed"
                    className="block w-full pl-10 pr-3 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter first name"
                  />
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FiUser className="h-5 w-5 text-gray-400" />
                  </div>
                </div>
                {errors.fname && (
                  <p className="mt-1 text-sm text-red-600">{errors.fname}</p>
                )}
              </div>

              {/* Last Name */}
              <div className="relative">
                <label
                  htmlFor="lname"
                  className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
                >
                  Last Name <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <input
                    type="text"
                    id="lname"
                    name="lname"
                    value={formData.lname}
                    onChange={handleChange}
                    pattern="[a-zA-Z0-9\s]+"
                    title="Only letters and numbers are allowed"
                    className="block w-full pl-10 pr-3 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter last name"
                  />
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FiUser className="h-5 w-5 text-gray-400" />
                  </div>
                </div>
                {errors.lname && (
                  <p className="mt-1 text-sm text-red-600">{errors.lname}</p>
                )}
              </div>
            </div>

            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
              {/* Email */}
              <div className="relative">
                <label
                  htmlFor="email"
                  className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
                >
                  Email <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="block w-full pl-10 pr-3 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter email address"
                  />
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FiMail className="h-5 w-5 text-gray-400" />
                  </div>
                </div>
                {errors.email && (
                  <p className="mt-1 text-sm text-red-600">{errors.email}</p>
                )}
              </div>

              {/* Phone */}
              <div className="relative">
                <label
                  htmlFor="mobileNumber"
                  className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
                >
                  Phone <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <input
                    type="number"
                    id="mobileNumber"
                    name="mobileNumber"
                    value={formData.mobileNumber}
                    onChange={handleChange}
                    className="block w-full pl-10 pr-3 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    placeholder="Enter phone number"
                  />
                  <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <FiPhone className="h-5 w-5 text-gray-400" />
                  </div>
                </div>
                {errors.mobileNumber && (
                  <p className="mt-1 text-sm text-red-600">
                    {errors.mobileNumber}
                  </p>
                )}
              </div>
            </div>

            {![
              "COMPANY",
              "VICE_PRESIDENT",
              "MANAGER",
              "TEAM_LEAD",
              "HR",
            ].includes(user.accountType) && (
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-3">
                <div className="relative">
                  <label
                    htmlFor="staffLimit"
                    className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
                  >
                    Staff Limit
                  </label>
                  <div className="relative">
                    <input
                      type="number"
                      id="staffLimit"
                      name="staffLimit"
                      min="0"
                      {...(user.accountType !== "SUPER_SUPER_ADMIN" && {
                        max: staffLimitData?.totalStaffLimit || 0,
                      })}
                      value={formData.staffLimit}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 dark:bg-gray-900 dark:text-white focus:border-blue-500"
                      placeholder="Enter staff limit"
                    />
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <FiUser className="h-5 w-5 text-gray-400" />
                    </div>
                  </div>
                  {errors.staffLimit && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors.staffLimit}
                    </p>
                  )}
                </div>
                <div className="relative">
                  <label
                    htmlFor="smsSendRate"
                    className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
                  >
                    SMS Rate
                  </label>
                  <div className="relative">
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      id="smsSendRate"
                      name="smsSendRate"
                      value={formData.smsSendRate}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 dark:bg-gray-900 dark:text-white focus:border-blue-500"
                      placeholder="Enter SMS rate"
                    />
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <FiMail className="h-5 w-5 text-gray-400" />
                    </div>
                  </div>
                  {/* {errors.smsSendRate && (
                      <p className="mt-1 text-sm text-red-600">
                        {errors.smsSendRate}
                      </p>
                    )} */}
                </div>

                <div className="relative">
                  <label
                    htmlFor="emailSendRate"
                    className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
                  >
                    Email Rate
                  </label>
                  <div className="relative">
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      id="emailSendRate"
                      name="emailSendRate"
                      value={formData.emailSendRate}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 dark:bg-gray-900 dark:text-white focus:border-blue-500"
                      placeholder="Enter email rate"
                    />
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <FiMail className="h-5 w-5 text-gray-400" />
                    </div>
                  </div>
                  {/* {errors.emailSendRate && (
                      <p className="mt-1 text-sm text-red-600">
                        {errors.emailSendRate}
                      </p>
                    )} */}
                </div>
              </div>
            )}

            {![
              "COMPANY",
              "VICE_PRESIDENT",
              "MANAGER",
              "TEAM_LEAD",
              "HR",
            ].includes(user.accountType) && (
              <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                {/* Total SMS Amount */}
                <div className="relative">
                  <label
                    htmlFor="totalSMSAmount"
                    className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
                  >
                    Total SMS Amount
                  </label>
                  <div className="relative">
                    <input
                      type="number"
                      id="totalSMSAmount"
                      name="totalSMSAmount"
                      min="0"
                      value={formData.totalSMSAmount}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-3 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter Total SMS Amount"
                    />
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <FiUser className="h-5 w-5 text-gray-400" />
                    </div>
                  </div>
                  {/* {errors.fname && (
                  <p className="mt-1 text-sm text-red-600">{errors.fname}</p>
                )} */}
                </div>

                {/* Total Email Amount */}
                <div className="relative">
                  <label
                    htmlFor="totalEmailAmount"
                    className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
                  >
                    Total Email Amount
                  </label>
                  <div className="relative">
                    <input
                      type="number"
                      id="totalEmailAmount"
                      name="totalEmailAmount"
                      min="0"
                      value={formData.totalEmailAmount}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-3 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                      placeholder="Enter Total Email Amount"
                    />
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <FiUser className="h-5 w-5 text-gray-400" />
                    </div>
                  </div>
                </div>
                {/* {errors.lname && (
                  <p className="mt-1 text-sm text-red-600">{errors.lname}</p>
                )} */}

                <div className="relative w-full">
                  <label
                    htmlFor="balanceExpiryDate"
                    className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
                  >
                    Balance Expiry Date <span className="text-red-500">*</span>
                  </label>

                  <div className="relative">
                    {/* Calendar Icon */}
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <FiCalendar className="h-5 w-5 text-gray-400" />
                    </div>

                    {/* Date Input */}
                    <input
                      type="date"
                      id="balanceExpiryDate"
                      name="balanceExpiryDate"
                      min={new Date().toISOString().split("T")[0]}
                      value={formData.balanceExpiryDate}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-10 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                  </div>

                  {/* Error Message */}
                  {errors.balanceExpiryDate && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors.balanceExpiryDate}
                    </p>
                  )}
                </div>
              </div>
            )}

            {/* Password */}
            <div className="relative">
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
              >
                Password <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="block w-full pl-10 pr-10 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Enter password"
                />
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <FiLock className="h-5 w-5 text-gray-400" />
                </div>
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? (
                    <FiEyeOff className="h-5 w-5 text-gray-400 hover:text-gray-500" />
                  ) : (
                    <FiEye className="h-5 w-5 text-gray-400 hover:text-gray-500" />
                  )}
                </button>
              </div>
              {errors.password && (
                <p className="mt-1 text-sm text-red-600">{errors.password}</p>
              )}
            </div>

            <div
              className={`grid gap-6 ${
                showValidityFields ? "sm:grid-cols-3" : "sm:grid-cols-1"
              }`}
            >
              {/* Valid From - only shown for Reseller, SUPER_ADMIN, SUPER_SUPER_ADMIN */}
              {showValidityFields && (
                <div className="relative">
                  <label
                    htmlFor="validityFrom"
                    className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
                  >
                    Valid From <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type="date"
                      id="validityFrom"
                      name="validityFrom"
                      min={new Date().toISOString().split("T")[0]}
                      value={formData.validityFrom}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-3 dark:bg-gray-900 dark:text-white py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <FiCalendar className="h-5 w-5 text-gray-400" />
                    </div>
                  </div>
                  {errors.validityFrom && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors.validityFrom}
                    </p>
                  )}
                </div>
              )}

              {/* Valid To - only shown for Reseller, SUPER_ADMIN, SUPER_SUPER_ADMIN */}
              {showValidityFields && (
                <div className="relative">
                  <label
                    htmlFor="validityTo"
                    className="block text-sm font-medium text-gray-700 mb-1 dark:text-white"
                  >
                    Valid To <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type="date"
                      id="validityTo"
                      name="validityTo"
                      value={formData.validityTo}
                      min={new Date().toISOString().split("T")[0]}
                      onChange={handleChange}
                      className="block w-full pl-10 pr-3 py-2 dark:bg-gray-900 dark:text-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                    />
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <FiCalendar className="h-5 w-5 text-gray-400" />
                    </div>
                  </div>
                  {errors.validTo && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors.validityTo}
                    </p>
                  )}
                </div>
              )}
            </div>

            {/* Form Actions */}
            <div className="flex justify-end space-x-4 pt-6">
              <button
                type="button"
                onClick={handleReset}
                className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                Reset
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className={`px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#673AB7] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 ${
                  isSubmitting ? "opacity-75 cursor-not-allowed" : ""
                }`}
              >
                {isSubmitting ? (
                  <>
                    <svg
                      className="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Processing...
                  </>
                ) : (
                  "Create Account"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AccountForm;